import { render } from "./CrosswordPointer.vue?vue&type=template&id=7a8f5445"
import script from "./CrosswordPointer.vue?vue&type=script&lang=js"
export * from "./CrosswordPointer.vue?vue&type=script&lang=js"

import "./CrosswordPointer.vue?vue&type=style&index=0&id=7a8f5445&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__